
<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} ANGGARAN</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        
        <vs-row>
          <vs-col vs-w="12" class="">
            <vs-input label="Anggaran" v-model="dataAnggaran" class="w-full" name="item-anggaran" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('item-anggaran')">{{ errors.first('item-anggaran') }}</span>
          </vs-col>
        </vs-row>
        
        <vs-row class="mt-4">

          <vs-col vs-w="2">
            <vs-input label="Tahun" v-model="dataTahun" class="pr-2 w-full" name="item-tahun"/>
            <span class="text-danger text-sm" v-show="errors.has('item-tahun')">{{ errors.first('item-tahun') }}</span>
          </vs-col>
          
          <vs-col vs-w="2">
            <p class="text-sm">Warna</p>
            <input label="Warna" v-model="dataColorx" type="color" name="item-color" class="mt-2">
          </vs-col>
          
          <vs-col vs-w="2" class="flex">
            <vs-input label="Jumlah" v-model="dataUnit" class="w-full" name="item-unit" v-validate="'required|numeric'" />
            <span class="text-danger text-sm" v-show="errors.has('item-unit')">{{ errors.first('item-unit') }}</span>
          </vs-col>

          <vs-col vs-w="6" class="flex">
            <vs-select
              label="Tipe Anggaran"
              v-model="dataTipeAnggaran"
              v-validate="'required'"
              class=""
              >
                <vs-select-item value="0" text="Tidak ada"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listTipeAnggaran"/>
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('tipe-anggaran')">{{ errors.first('tipe-anggaran') }}</span>
            <vs-button class="mt-6" @click.stop="tambahTipeAnggaran=true" >+</vs-button>
          </vs-col>
        </vs-row>

        <vs-row class="mt-4">
          <vs-col vs-w="4">
            <vs-input label="Luas" v-model="dataLuas" class="pr-2 w-full" name="item-jumlah"/>
            <span class="text-danger text-sm" v-show="errors.has('item-jumlah')">{{ errors.first('item-harga') }}</span>
          </vs-col>

          <vs-col vs-w="4" class="flex">
            <vs-select
              label="Satuan"
              v-model="dataSatuan"
              v-validate="'required'"
              class="w-full"
              >
                <vs-select-item value="0" text="Tidak ada"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listSatuan"/>
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('satuan')">{{ errors.first('satuan') }}</span>
            <vs-button class="py-3 mt-6" @click.stop="tambahSatuan=true" >+</vs-button>
          </vs-col>
        </vs-row>
        
        <vs-row class="mt-6">
          <vs-col vs-w="12">
            <vs-textarea label="Lokasi" v-model="dataLokasi" class="w-full" name="item-lokasi" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('item-lokasi')">{{ errors.first('item-lokasi') }}</span>
          </vs-col>
        </vs-row>
        
        <vs-row class="mt-2">
          <vs-col vs-w="12">
            <span class="text-sm">Tanggal Mulai</span>
            <datepicker name="item-tanggal" v-model="dataTanggal" v-validate="'required'" format="yyyy-MM-dd"></datepicker>
            <span class="text-danger text-sm" v-show="errors.has('item-tanggal')">{{ errors.first('item-tanggal') }}</span>
          </vs-col>
        </vs-row>

        <vs-row class="mt-4">
          <vs-col vs-w="12">
            <GmapMap
              :center="center"
              :zoom="4"
              :options="{
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUi: false
              }"
              map-type-id="terrain"
              style="width: 100%; height: 400px">
                <GmapMarker
                  :position="position"
                  :clickable="true"
                  :draggable="true"
                  @click="center=position"
                  @drag="updateCoordinates"
                />
            </GmapMap>
            <!--
            <vs-button class="mr-6" @click="cekKor">kor</vs-button>
            -->
          </vs-col>
        </vs-row>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>

    <vs-prompt
      color="success"
      title="Tambah Satuan"
      @accept="satuanAdd"
      @close="close"
      :active.sync="tambahSatuan"
      style="z-index: 52011;">
      <div class="con-exemple-prompt">
        <vs-input placeholder="Satuan" data-vv-name="addsatuan" name="addsatuan" v-validate="'required'" v-model="addSatuan"/>
        <span class="text-danger text-sm" v-show="errors.has('addsatuan')">{{ errors.first('addsatuan') }}</span>
       </div>
     </vs-prompt>

    <vs-prompt
      color="success"
      title="Tambah Tipe Anggaran"
      @accept="tipeAnggaranAdd"
      @close="close"
      :active.sync="tambahTipeAnggaran"
      style="z-index: 52011;">
      <div class="con-exemple-prompt">
        <vs-input placeholder="Tipe Anggaran" data-vv-name="addtipeanggaran" name="addtipeanggaran" v-validate="'required'" v-model="addTipeAnggaran"/>
        <span class="text-danger text-sm" v-show="errors.has('addtipeanggaran')">{{ errors.first('addtipeanggaran') }}</span>
       </div>
     </vs-prompt>

  </vs-sidebar>

</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import { CurrencyDirective } from 'vue-currency-input'
import Datepicker from 'vuejs-datepicker';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    Datepicker
  },
  directives: {
    currency: CurrencyDirective
  },
  data () {
    return {

      dataId: null,
      dataParent: 0,
      dataTipeAnggaran: 0,
      dataAnggaran: null,
      dataTanggal: null,
      dataColorx:'#3dc9b3',
      dataLuas: null,
      dataSatuan: 0,
      dataTahun: null,
      dataUnit: 1,
      dataLokasi: null,

      center: { lat: -5.1181464, lng: 119.1024968 },
      position: { lat: -5.1181464, lng: 119.1024968 },

      listTipeAnggaran: [],
      addTipeAnggaran: null,
      tambahTipeAnggaran: false,

      listSatuan: [],
      addSatuan: null,
      tambahSatuan: false,

      settings: {
        maxScrollbarLength: 80,
        wheelSpeed: .80
      }
    }
  },
  watch: {
    isSidebarActive (val) {      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id, task_title, task_unit, task_quantity, task_parent, tahun, lokasi, lat, lng, color, luas, tanggal, tipe_anggaran  } = JSON.parse(JSON.stringify(this.data))
        
        this.dataId = id
        this.dataTipeAnggaran = tipe_anggaran
        this.dataAnggaran = task_title
        this.dataSatuan = task_unit
        this.dataUnit = task_quantity
        if (task_parent != 0) {
          this.dataParent = task_parent
        } else {
          this.dataParent = id
        }

        this.dataTahun = tahun
        this.dataLuas = luas
        this.dataLokasi = lokasi
        this.position = {
          lat: parseFloat(lat),
          lng: parseFloat(lng)
        }
        this.dataColorx = color
        this.dataTanggal = tanggal

        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataTipeAnggaran && this.dataAnggaran && this.dataLuas && this.dataSatuan && this.dataTahun && this.dataUnit && this.dataLokasi
    },
    validateTipeAnggaran() {
      return !this.errors.any() && this.addTipeAnggaran !== null
    },
    validateSatuan() {
      return !this.errors.any() && this.addSatuan !== null
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    }),
  },
  mounted(){
    let configs = {
      headers: {
        'Authorization': 'Bearer ' + this.user.api_token,
      },
    }
    this.axios.get('/term-list/tipe-anggaran', configs)
    .then((response) => {
      let {data} = response.data
      this.listTipeAnggaran = data
    })
    .catch((error) => {
      let data = error.data
      this.listTipeAnggaran = data
    })
    this.axios.get('/term-list/satuan', configs)
    .then((response) => {
      let {data} = response.data
      this.listSatuan = data
    })
    .catch((error) => {
      let data = error.data
      this.listSatuan = data
    })
  },
  methods: {
    updateCoordinates(location) {
      /*
      alert(location.getCenter().lat())
      this.position = {
          lat: location.getCenter().lat(),
          lng: location.getCenter().lng(),
      };
      */
      this.position = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataTipeAnggaran = 0
      this.dataAnggaran = null
      this.dataTanggal = null
      this.dataGroup = 0
      this.dataParent = 0
      this.dataHarga = null
      this.dataSatuan = 0
      this.position = { lat: -5.1181464, lng: 119.1024968 }
    },
    close() {
      this.$emit('closed', false)
    },
    cekKor () {
      alert(this.center.lat);
    },
    tipeAnggaranAdd() {
      this.$vs.loading()
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      let formData = {
        name : this.addTipeAnggaran,
        term_group: 0,
        parent: 0,

        taxonomy: 'tipe-anggaran'
      }

      this.axios.post('/term-add', formData, configs)
      .then((response) => {
        this.listTipeAnggaran = []
        this.addTipeAnggaran = null
        this.loadTipeAnggaran()

        this.$vs.notify({
          title: response.message,
          color  : 'success',
          text  : 'Tipe Anggaran telah bertambah',
        })
        this.$vs.loading.close()

      })
      .catch((error) => {
        this.$vs.loading.close()
        let { data } = error.response

        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    loadTipeAnggaran () {
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/term-list/tipe-anggaran', configs)
      .then((response) => {
        let {data} = response.data
        this.listTipeAnggaran = data
      })
      .catch((error) => {
        let data = error.data
        this.listTipeAnggaran = data
      })
    },
    satuanAdd() {
      this.$vs.loading()
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      let formData = {
        name : this.addSatuan,
        term_group: 0,
        parent: 0,

        taxonomy: 'satuan'
      }

      this.axios.post('/term-add', formData, configs)
      .then((response) => {
        this.listSatuan = []
        this.addSatuan = null
        this.loadSatuan()

        this.$vs.notify({
          title: response.message,
          color  : 'success',
          text  : 'Satuan telah bertambah',
        })
        this.$vs.loading.close()

      })
      .catch((error) => {
        this.$vs.loading.close()
        let { data } = error.response

        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    loadSatuan () {
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/term-list/satuan', configs)
      .then((response) => {
        let {data} = response.data
        this.listSatuan = data
      })
      .catch((error) => {
        let data = error.data
        this.listSatuan = data
      })
    },
    formatDate(date) {
      const dt = new Date(date);
      let mon = dt.getMonth() + 1;
      let day = dt.getDate();

      if (mon.length < 2)
        mon = '0' + mon;
      if (day.length < 2)
        day = '0' + day;

      return dt.getFullYear() + '-' + mon + '-' + day;
    },
    formatDatee(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;

      return [year, month, day].join('-');
    },
    submitData () {
      this.$vs.loading()
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {

            id: this.dataId,
            task_title: this.dataAnggaran,
            task_total: 0,
            task_unit: this.dataSatuan,
            task_price: 0,
            task_quantity: this.dataUnit,
            task_parent: this.dataParent,
            task_type: 'perencanaan',
            task_sub_type: 'anggaran',
            task_status: 'publish',
            task_group: 'null',
            comment_status: 'null',
            task_password: 'null',

            meta : {
              tipe_anggaran: this.dataTipeAnggaran,
              tahun: this.dataTahun,
              luas: this.dataLuas,
              lokasi: this.dataLokasi,
              lat: this.position.lat,
              lng: this.position.lng,
              color: this.dataColorx,
              tanggal: this.formatDatee(this.dataTanggal)
            },

          }
          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('anggaran/updateAnggaran', obj)
            .then((response) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
            })
            .catch(error => {
              this.$vs.loading.close()
              let {data} = error.response
              this.$vs.notify({
                title: 'Error',
                text: data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          } else {
            delete obj.id
            this.$store.dispatch('anggaran/addAnggaran', obj)
            .then((response) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
            })
            .catch(error => {
              this.$vs.loading.close()
              let {data} = error.response
              this.$vs.notify({
                title: 'Error',
                text: data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          }
          this.initValues()
          this.$emit('closeSidebar')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 550px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
